import { copyText } from './copy';

/**
 * Step 3 "One Final Touch" (ALBAU-882, Figma frame 6) is the card builder's first page with packaging
 * copy, Figma cards and the predesigned card as a third option. Applied once at boot when the flag is on.
 * @param {Record<string, any>} pages - the shared page config from context/pages.js
 * @returns {Record<string, any>}
 */
export function applyPackagingPageOverrides(pages) {
  const images = window.giftWrapData?.insertsAndCards?.images ?? {};
  Object.assign(pages.addPersonalTouch, {
    titleBar: copyText('step3TitleBar', 'ONE FINAL TOUCH'),
    heading: copyText('step3Heading', 'Add your message'),
    description: copyText('step3Intro', 'Choose a card and add a message for them inside.'),
    backTo: 'firstPage',
    autoAdvance: false,
    cardStyle: 'packaging',
    options: [
      {
        icon: 'boxInsert',
        title: copyText('insertTitle', 'Box insert'),
        subtitle: copyText('insertSubtitle', 'A printed card inside the product box'),
        imageUrl: images.insertImageTextThumbnail ?? '',
        clicksTo: 'boxInsertUploadOrText'
      },
      {
        icon: 'greetingsCard',
        title: copyText('cardTitle', 'Greetings card'),
        subtitle: copyText('cardSubtitle', 'A bespoke card you design'),
        imageUrl: images.greetingsCardImageTextThumbnail ?? '',
        clicksTo: 'cardChoice'
      },
      {
        icon: 'greetingsCardPredesigned',
        title: copyText('xmasTitle', 'Merry Christmas Card'),
        subtitle: copyText('xmasSubtitle', 'Gold foil greetings card. Add your own message inside.'),
        // 16:9 hero asset; the 140px modal thumbnail is only a fallback.
        imageUrl: images.packagingChristmasCardHero ?? images.greetingsCardPredesignedThumbnail ?? '',
        hero: true,
        clicksTo: 'cardBlankPredesigned',
        // Opens the gold-foil picker on the design whose variant title contains this (case-insensitive).
        preselectTheme: 'christmas'
      }
    ],
    buttons: [
      {
        label: 'Continue',
        disabled: { noSelections: true, hasSelections: false },
        clicksTo: { selections: ['boxInsertUploadOrText', 'cardChoice', 'cardBlankPredesigned', 'FINISHED'] }
      },
      { label: 'Skip', disabled: false, hidden: false, clicksTo: 'FINISHED' }
    ]
  });
  // The predesigned card is reached from step 3 and from cardBlankMessageChoice; Back returns to whichever
  // the customer came from (UvInsertsNavContext), else its static backTo.
  pages.cardBlankPredesigned.backToEntryPage = true;
  return pages;
}
